import { IonicPage } from 'ionic-angular';
import { Component } from '@angular/core';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { VesselService } from '../../../services/vessel/vessel.service';
import { SetupService } from '../../../services/setup/setup.service';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { ImplementerSnapshotSummary } from '../../../models/implementer/implementer.models';
import { ImplementerService } from '../../../services/implementer/implementer.service';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-default',
  templateUrl: 'default-page.html',
})
export class DefaultPage {

  config = AppConfig.settings;
  latestSnapshotSummary: ImplementerSnapshotSummary;
  implementerSnapshotLoading: boolean;

  constructor(
    public vesselService: VesselService,
    public setupService: SetupService,
    public navHelperService: NavHelperService,
    private implementerService: ImplementerService,
  ) {
  }

  async ionViewDidEnter() {
    this.setupService.checkInitialSetupComplete().then(result => {
      this.navHelperService.updateInitialSetupComplete(result);
    });

    if (this.config.isImplementerEnvironment) {
      this.implementerSnapshotLoading = true;
      this.latestSnapshotSummary = await this.implementerService.getLatestSnapshotSummary(this.config.isVesselEnvironment);
      this.implementerSnapshotLoading = false;
    }

    this.setupService
      .getSetupSummary(new PtLuxonDate(), true)
      .then(summary => {
        this.setupService.saveSetup(summary);
        const setupNeeded = summary.phaseId == null ||
          summary.projectId == null ||
          summary.stageId == null;

        this.navHelperService.updateSetupConfigured(!setupNeeded);
      });
  }

  ionViewDidLoad() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/default/default-page/default-page.ts